/**
 * @file /view route definitions.
 */
import React from 'react';
import { Route } from 'react-router-dom';

import ViewAlbumRedirectContainer from '../containers/view/ViewAlbumRedirectContainer';
import RedirectWithStatus from '../components/routing/RedirectWithStatus';

const routes = [
  {
    path: '/view/album/redirect',
    exact: false,
    component: ViewAlbumRedirectContainer,
  },
  {
    path: '/view/album/:albumId',
    exact: false,
    component: () => (
      <Route
        path="/view/album/:albumId"
        render={({ match }) => (
          <RedirectWithStatus
            status={301}
            to={`/app/shutterbug/hierarchy-items/${match.params.albumId}/matches`}
          />
        )}
      />
    ),
  },
];

export default routes;
